import { configureStore } from "@reduxjs/toolkit"
import reviewsSlice from "./slices/reviews-slice.js"
import visitorSlice from "./slices/visitor-slice.js"
import logoSlice from "./slices/logo-slice.js"
import servicesSlice from "./slices/services-slice.js"
import faqSlice from "./slices/faq-slice.js"
import catalogSlice from "./slices/catalog-slice.js"
import productsSlice from "./slices/products-slice.js"
import categoriesSlice from "./slices/categories-slice.js"



export const store = configureStore({
    reducer: {
        reviews: reviewsSlice,
        visitor: visitorSlice,
        logo: logoSlice,
        services: servicesSlice,
        faq: faqSlice,
        catalog: catalogSlice,
        products: productsSlice,
        categories: categoriesSlice,
        faq: faqSlice
    }
})